import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Channel } from './channel'
import type { EvoGetConnectionDto } from './dto/evo-get-connection.dto'

export class ChannelsRepository extends BaseRepository<Channel> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.brokerApiUrl + '/' + 'channels', token, cache)
    }

    async evoGetConnection(channelId: string): Promise<EvoGetConnectionDto> {
        const { json, statusCode, message } = await this.request.get(
            this.config.brokerApiUrl + '/channels/' + channelId + '/evo/connection?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async evoLogout(channelId: string): Promise<any> {
        const { json, statusCode, message } = await this.request.get(
            this.config.brokerApiUrl + '/channels/' + channelId + '/evo/logout?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async uazapiGetConnection(channelId: string): Promise<EvoGetConnectionDto> {
        const { json, statusCode, message } = await this.request.get(
            this.config.brokerApiUrl + '/channels/' + channelId + '/uazapi/connection?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async uazapiLogout(channelId: string): Promise<any> {
        const { json, statusCode, message } = await this.request.get(
            this.config.brokerApiUrl + '/channels/' + channelId + '/uazapi/logout?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async wabaLogout(channelId: string): Promise<any> {
        const { json, statusCode, message } = await this.request.get(
            this.config.brokerApiUrl + '/channels/' + channelId + '/waba/logout?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async wabaToken(channelId: string, code: string): Promise<any> {
        const { json, statusCode, message } = await this.request.post(
            this.config.brokerApiUrl + '/channels/' + channelId + '/waba/token?token=' + this.resolvedToken,
            { code },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async gmailLogout(channelId: string): Promise<any> {
        const { json, statusCode, message } = await this.request.get(
            this.config.brokerApiUrl + '/channels/' + channelId + '/gmail/logout?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async gmailToken(channelId: string, code: string, redirectUri: string): Promise<any> {
        const { json, statusCode, message } = await this.request.post(
            this.config.brokerApiUrl + '/channels/' + channelId + '/gmail/token?token=' + this.resolvedToken,
            { code, redirectUri },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getAppData(): Promise<any> {
        const { json, statusCode, message } = await this.request.get(this.config.brokerApiUrl + '/channels/app')
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
